import { useSession } from 'next-auth/react';
import styles from './styles.module.scss';
import { PuffLoader, PulseLoader } from 'react-spinners';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faDotCircle, faXmark } from '@fortawesome/free-solid-svg-icons';
import Image from 'next/image';
import { useState, useEffect, useRef } from 'react';
import { useSocket } from '../../Context/socket';

export default function ConversationComponent({ allConvoData, displayedConvos, convoCategory, chooseConvoCategory, setOpenMessanger, setViewConversation }) {
    const { data: session, status } = useSession();
    const [searchResults, setSearchResults] = useState(displayedConvos);

    useEffect(() => {
        setSearchResults(displayedConvos);
    }, [displayedConvos]);

    function handleSearch(query) {
        if (query.trim() === "") {
            setSearchResults(displayedConvos);
            return;
        }

        const filteredConvos = displayedConvos.filter(convo => {
            const otherUser = session?.user?.token?.username === convo.receiver ? convo.sender : convo.receiver;
            const chatTitle = convo.chatTitle ? convo.chatTitle.toLowerCase() : '';
            const lastMessage = convo.messages[convo.messages.length - 1]?.message.toLowerCase() || '';

            return otherUser.toLowerCase().includes(query.toLowerCase()) || chatTitle.includes(query.toLowerCase()) || lastMessage.includes(query.toLowerCase());
        });

        setSearchResults(filteredConvos);
    }

    function countMissedMessagesByCategory(category) {
        if (!session) return 0;
        if (status !== 'authenticated') return 0;
        if (allConvoData === null) return 0;
        let totalMissedMessages = 0;

        const getCategory = category.toLowerCase();

        allConvoData[getCategory].forEach(convo => {
            convo.messages.forEach(message => {
                if (!message.viewed.includes(session.user.token.username)) {
                    totalMissedMessages++;
                }
            });
        });

        return totalMissedMessages;
    }

    const activeButtonStyle = {
        backgroundColor: 'black',
        fontWeight: '600',
        borderColor: 'black',
        color: 'white'
    }


    const containerRef = useRef(null);
    const [showTopHazyBar, setShowTopHazyBar] = useState(false);
    const [showBottomHazyBar, setShowBottomHazyBar] = useState(true);
  
    const handleScroll = () => {
        if (containerRef.current) {
          const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
          setShowTopHazyBar(scrollTop > 0);
          setShowBottomHazyBar(scrollTop + clientHeight < scrollHeight);
        }
      };
  
    useEffect(() => {
      const container = containerRef.current;
      if (container) {
        container.addEventListener('scroll', handleScroll);
        handleScroll(); // Initial check
      }
      return () => {
        if (container) {
          container.removeEventListener('scroll', handleScroll);
        }
      };
    }, []);

    return (
        <div id={styles.conversationComponent}>
            <section id={styles.header}>
                <h1>Chats</h1>
                <FontAwesomeIcon onClick={() => setOpenMessanger(false)} icon={faChevronRight} id={styles.exit} />
            </section>
            <section id={styles.options}>
                <input onChange={(e) => handleSearch(e.target.value)} type='text' placeholder='Search Messages' />
                <div>
                    <button onClick={() => chooseConvoCategory('General')} style={convoCategory === 'General' ? activeButtonStyle : {display: allConvoData.general.length === 0 ? 'none' : 'flex'}}>General <b style={{display: countMissedMessagesByCategory('General') === 0 ? 'none' : 'flex'}}>{countMissedMessagesByCategory('General')}</b></button>
                    <button onClick={() => chooseConvoCategory('Marketplace')} style={convoCategory === 'Marketplace' ? activeButtonStyle : {display: allConvoData.marketplace.length === 0 ? 'none' : 'flex'}}>Marketplace <b style={{display: countMissedMessagesByCategory('Marketplace') === 0 ? 'none' : 'flex'}}>{countMissedMessagesByCategory('Marketplace')}</b></button>
                    <button onClick={() => chooseConvoCategory('Events')} style={convoCategory === 'Events' ? activeButtonStyle : {display: allConvoData.events.length === 0 ? 'none' : 'flex'}}>Events <b style={{display: countMissedMessagesByCategory('Events') === 0 ? 'none' : 'flex'}}>{countMissedMessagesByCategory('Events')}</b></button>
                    <button onClick={() => chooseConvoCategory('Vendors')} style={convoCategory === 'Vendors' ? activeButtonStyle : {display: allConvoData.vendors.length === 0 ? 'none' : 'flex'}}>Vendors <b style={{display: countMissedMessagesByCategory('Vendors') === 0 ? 'none' : 'flex'}}>{countMissedMessagesByCategory('Vendors')}</b></button>
                    <button onClick={() => chooseConvoCategory('Jobs')} style={convoCategory === 'Jobs' ? activeButtonStyle : {display: allConvoData.jobs.length === 0 ? 'none' : 'flex'}}>Jobs <b style={{display: countMissedMessagesByCategory('Jobs') === 0 ? 'none' : 'flex'}}>{countMissedMessagesByCategory('Jobs')}</b></button>
                    <button onClick={() => chooseConvoCategory('Auctions')} style={convoCategory === 'Auctions' ? activeButtonStyle : {display: allConvoData.auctions.length === 0 ? 'none' : 'flex'}}>Auctions <b style={{display: countMissedMessagesByCategory('Auctions') === 0 ? 'none' : 'flex'}}>{countMissedMessagesByCategory('Auctions')}</b></button>
                    <button onClick={() => chooseConvoCategory('Raffles')} style={convoCategory === 'Raffles' ? activeButtonStyle : {display: allConvoData.raffles.length === 0 ? 'none' : 'flex'}}>Raffles <b style={{display: countMissedMessagesByCategory('Raffles') === 0 ? 'none' : 'flex'}}>{countMissedMessagesByCategory('Raffles')}</b></button>
                </div>
            </section>
            <section id={styles.convos}>
                { showTopHazyBar && <div id={styles.overflowTopBar} /> }
                { showBottomHazyBar && <div id={styles.overflowBottomBar} /> }
                <section ref={containerRef}>
                    { searchResults === null && <PulseLoader size={20} color='#4169E1' /> }
                    { searchResults && searchResults.length > 0 && searchResults.map((convo, index) => <ConvoCard key={index} convo={convo} setViewConversation={setViewConversation} /> ) }
                    { searchResults && searchResults.length === 0 && <h1>No Conversations</h1> }
                </section>
            </section>
        </div>
    )
}


const ConvoCard = ({ convo, setViewConversation }) => {

    const { onlineUsers } = useSocket();

    const { data: session, status } = useSession();

    const otherUser = session?.user?.token?.username === convo.receiver ? convo.sender : convo.receiver
    const chatImage = convo.chatImage;
    const [pfpLoaded, setPfpLoaded] = useState(false);

    const lastMessage = convo.messages[convo.messages.length - 1];
    const otherUserReadLastMessage = lastMessage.viewed.includes(otherUser);
    const myUserReadLastMessage = lastMessage.viewed.includes(session.user.token.username);

    return  (
        <div className={styles.convoCard} onClick={() => setViewConversation({ convoID: convo._id.toString(), requestingUserID: session.user.token.id })}>
            <section>
                <span style={{display: pfpLoaded === true ? 'none' : 'flex'}}> <PuffLoader size={20} color='#4169E1' /> </span>
                <Image sizes='auto auto' fill objectFit='cover' src={chatImage} alt="pfp" onLoadingComplete={() => setPfpLoaded(true)} />
            </section>
            <section>
                <h1 style={{fontWeight: myUserReadLastMessage ? '500' : '900'}}>{ !convo?.chatTitle ? <> {otherUser} <b id={styles.status} style={{color: onlineUsers.includes(otherUser) ? '#0da00d' : 'white'}} >{'\u00B7'}</b> </> : convo.chatTitle }</h1>
                <span><p>{lastMessage.message}</p> <span style={{marginLeft: '6px'}}>•</span> <b style={{marginLeft: '6px'}}>{formatTimeDifference(lastMessage.timestamp)}</b></span>
            </section>
            <section>
                { otherUserReadLastMessage && !myUserReadLastMessage && <FontAwesomeIcon id={styles.icon} icon={faDotCircle} /> }

                { otherUserReadLastMessage && myUserReadLastMessage && <div>
                    <Image sizes='auto auto' fill objectFit='cover' src={chatImage} alt="pfp" />
                </div> }

                { myUserReadLastMessage && <div>
                    <Image sizes='auto auto' fill objectFit='cover' src={session.user.token.pfp === '' ? '/profile/defaultUser.jpg' : session.user.token.pfp} alt="pfp" />
                </div> }
            </section>
        </div>
    )
}

function formatTimeDifference(timestamp) {
    const currentDate = new Date();
    const messageDate = new Date(Date.parse(timestamp));
    const timeDifference = currentDate - messageDate;
    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (seconds < 15) {
        return "just now";
    } else if (seconds < 60) {
        return `${seconds}s`;
    } else if (minutes < 60) {
        return `${minutes}m`;
    } else if (hours < 24) {
        return `${hours}h`;
    } else if (days < 7) {
        return `${days}d`;
    } else if (weeks < 4) {
        return `${weeks}w`;
    } else if (months < 12) {
        return `${months}mo`;
    } else {
        return `${years}y`;
    }
}
